import React from "react";
import { useTranslation } from "react-i18next";
import { FiFilter, FiDownload, FiX } from "react-icons/fi";

const TransactionFilters = ({ filters, setFilters, onReset, onExport }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-base-100 rounded-xl border border-base-200 shadow-sm p-5 space-y-4">
      {/* Header row */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FiFilter className="text-primary text-base" />
          <h2 className="text-sm font-semibold text-base-content">
            {t("transactions.filtersTitle")}
          </h2>
        </div>
        <button
          onClick={onExport}
          className="btn btn-sm gap-2 btn-ghost border border-base-300 hover:bg-base-200"
        >
          <FiDownload className="text-sm" />
          {t("transactions.export")}
        </button>
      </div>

      {/* Filters grid */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-3 items-center">
        <select
          value={filters.type}
          onChange={(e) => setFilters({ ...filters, type: e.target.value })}
          className="select select-bordered bg-base-200 border-base-300 text-base-content focus:border-primary focus:outline-none"
        >
          <option value="">{t("transactions.allTypes")}</option>
          <option value="deposit">{t("transactions.deposit")}</option>
          <option value="withdrawal">{t("transactions.withdrawal")}</option>
        </select>

        <input
          type="text"
          placeholder={t("transactions.category")}
          className="input input-bordered bg-base-200 border-base-300 text-base-content focus:border-primary focus:outline-none"
          value={filters.category}
          onChange={(e) => setFilters({ ...filters, category: e.target.value })}
        />

        <input
          type="date"
          className="input input-bordered bg-base-200 border-base-300 text-base-content focus:border-primary focus:outline-none"
          value={filters.start}
          onChange={(e) => setFilters({ ...filters, start: e.target.value })}
        />

        <input
          type="date"
          className="input input-bordered bg-base-200 border-base-300 text-base-content focus:border-primary focus:outline-none"
          value={filters.end}
          onChange={(e) => setFilters({ ...filters, end: e.target.value })}
        />

        <button
          onClick={onReset}
          className="btn btn-ghost btn-sm border border-base-300 gap-2 hover:bg-base-200 w-full"
        >
          <FiX className="text-sm" />
          {t("transactions.reset")}
        </button>
      </div>
    </div>
  );
};

export default TransactionFilters;
